import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    donorName?: string,
    onClose: () => void
}

const DonorShieldInviteSentModal = (props: IProps) => {
    return (
        <Modal
            backdrop='static'
            show={props.show}
            onHide={props.onClose}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
            <Modal.Header closeButton>Donor Shield Invite Sent</Modal.Header>
            <Modal.Body>
                {props.donorName
                    ? `The Donor Shield invite has been sent for ${props.donorName}.`
                    : 'The Donor Shield invite has been sent.'}
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '0 none' }}>
                <Button bsStyle='primary' onClick={props.onClose}>OK</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DonorShieldInviteSentModal;
